import ctl from '@netlify/classnames-template-literals';

export const menuContainerStyle = ctl(`
  relative 
  z-10 
  bg-white 
  min-w-[50px] 
  rounded
`);

export const menuStyle = ctl(`
  absolute 
  top-[110%] 
  right-0 
  flex 
  flex-col 
  min-w-[250px] 
  shadow-cetacean-blue
  rounded
  bg-white 
  p-4 
  space-y-4
`);

export const iconStyle = ctl(`
  flex 
  items-center 
  justify-center 
  h-full 
  cursor-pointer
`);

export const containerStyle = ctl(`
  flex 
  mb-3 
  space-x-2
`);

export const applyButtonClasses = {
  container: 'bg-gunmetal self-end',
  text: 'text-[15px]',
};

export const searchClasses = {
  containerClasses: 'flex-1',
};
